import { render, staticRenderFns } from "./ClassListUpdateModal.vue?vue&type=template&id=3a63358d&scoped=true&"
import script from "./ClassListUpdateModal.vue?vue&type=script&lang=js&"
export * from "./ClassListUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./ClassListUpdateModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClassListUpdateModal.vue?vue&type=style&index=1&id=3a63358d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a63358d",
  null
  
)

export default component.exports